// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__21ui3","addWidgetButton":"Header_addWidgetButton__3Q-cy","dashboardTabs":"Header_dashboardTabs__qV7uG","active":"Header_active__9cMXq"};